import './Header.css'
import Logo from '../Assets/examlogo.webp'
import { CiSearch } from "react-icons/ci";
import { IoCartOutline, IoHomeOutline } from "react-icons/io5";
import { MdArrowDropDown, MdHeadsetMic } from "react-icons/md";
import { CiUser } from "react-icons/ci";
import { RiArrowDropDownLine } from "react-icons/ri";
import React, { useState, useRef, useEffect } from 'react';
import { GrPrevious } from "react-icons/gr";
import { GrNext } from "react-icons/gr";
import Menu from '@mui/material/Menu';

import { Link } from "react-router-dom";
import { BASE_URL, IMGAGE_URL } from '../Config';
import axios from 'axios';
import Menubar from '../Homepage/Mobileviewdrawer';
import { BiNotepad } from "react-icons/bi";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import { FaUser } from 'react-icons/fa';
import { FaVideo } from "react-icons/fa6";

import AnchorTemporaryDrawer from './HeaderDrawer';
import { LuLogIn } from 'react-icons/lu';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';

import { GiVideoConference } from 'react-icons/gi';
import { FcConferenceCall } from 'react-icons/fc';
import { BsCurrencyRupee } from 'react-icons/bs';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import Gif from '../Assets/Popular-ezgif.com-gif-maker.gif'
import RewardBanner from '../Homepage/RewardBanner';

function Header() {
    const userdatatoken = localStorage.getItem('userDatatoken');
    const token = localStorage.getItem('token_type');
    const [slideIndex, setSlideIndex] = useState(0);
    const sliderRef = useRef(null);
    const [itemWidth, setItemWidth] = useState(0);
    const [clickedItemData, setClickedItemData] = useState(null);
    const [value, setValue] = React.useState(0);
    const [anchorEl1, setAnchorEl1] = React.useState(null);
    const open1 = Boolean(anchorEl1);
    const handleClick1 = (event) => {
        setAnchorEl1(event.currentTarget);

    };
    const logout = (event) => {
        localStorage.clear();
        window.location.reload()
    };
    const handleClose1 = () => {
        setAnchorEl1(null);
    };

    const storedDeviceId = localStorage.getItem('deviceId');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        const firstItem = sliderRef.current?.querySelector('.menu-list-item');
        if (firstItem) {
            setItemWidth(firstItem.offsetWidth); // Use offsetWidth to get the width of the first item
        }
    }, []);

    const slide = (direction) => {
        const containerWidth = sliderRef.current.clientWidth; // Width of the slider container
        const itemWidth = sliderRef.current.children[0].clientWidth; // Width of each item
        const totalItems = data.length; // Total number of items in the array

        // Calculate the maximum slide distance based on the total number of items and the width of each item
        const maxSlide = Math.max(0, totalItems - 1) * itemWidth;

        // Calculate the new index based on the direction of the slide
        let newIndex;
        if (direction === 1) {
            // Slide to the right
            newIndex = Math.min(slideIndex + itemWidth, maxSlide);
        } else {
            // Slide to the left
            newIndex = Math.max(slideIndex - itemWidth, 0);
        }

        setSlideIndex(newIndex);
    };



    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        // event.preventDefault();
        setAnchorEl(event.currentTarget);

    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await axios.get(BASE_URL + 'headercategory');
                setData(response.data.data);

            } catch (error) {
                setError(error);
            } finally {
                // setLoading(false);
            }
        };

        fetchData();
    }, []);
    const [examType, setExamType] = useState([]);


    const fetchExamTypeData = async () => {
        try {
            const response = await axios.get(BASE_URL + 'exam-category');
            if (response.data && response.data.data) {
                setExamType(response.data.data);
            } else {
                setExamType([]);
            }

        } catch (error) {
            //   setError(error);
        } finally {
            //   setLoading(false);
        }
    };
    useEffect(() => {
        fetchExamTypeData();
    }, []);
    const handleClickdata = (item) => {
        // Set the clicked item's data in state
        setClickedItemData(item.childrens);
    };


    const [profileData, setProfileData] = useState(null);

    useEffect(() => {
        // Fetch profile data when the component mounts
        fetchProfileData();
    }, []);


    const [userdata1, setUserdata1] = useState('')
    const tokenid = 'Bearer' + userdatatoken
    const tokendata = tokenid.replace(/"/g, ' ');

    const fetchProfileData = async () => {
        // Loading.circle();
        axios.get(BASE_URL + 'profiles', {
            headers: {
                Accept: "application/json",
                Authorization: tokendata

            }
        }).then(({ data }) => {
            setUserdata1(data.data)
            localStorage.setItem('userData', JSON.stringify(data.data));
            // Loading.remove();
        })
    };

    const userdata = localStorage.getItem('userData');
    const [cartdata, setCartdata] = useState([])
    useEffect(() => {
        fetchCartData();
        fetchCartDataunauth();
        footersection();

    }, []);
    const fetchCartDataunauth = async () => {
        axios.post(BASE_URL + 'getcartunauth', { "device_id": storedDeviceId })
            .then(({ data }) => {
                if (data.data && data.data.data) {
                    setCartdata([]);
                } else {

                    setCartdata(data.data);
                }


            })
    };
    const fetchCartData = async () => {
        axios.get(BASE_URL + 'getCartauth', {
            headers: {
                Accept: "application/json",
                Authorization: tokendata

            }
        }).then(({ data }) => {
            if (data.data && data.data.data) {
                setCartdata([]);
            } else {

                setCartdata(data.data);
            }


        })
    };
    const [showdata, setShowdata] = useState('');
    const [sidebardata, setSidebardata] = useState('')
    // const [searchdata,setSearchdata] = useState([])
    const [searchText, setSearchText] = useState("");
    const [searchData, setSearchdata] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);


    const footersection = async () => {
        try {
            const response = await axios.get(`${BASE_URL}generalsetting`, {
                headers: {
                    "content-type": "multipart/form-data",
                    Accept: "application/json",
                },
            });
            if (response.data.success === true) {

                setShowdata(response.data.setting);
                setSidebardata(response.data.data)
            } else {
                setShowdata([]);
                setSidebardata([]);
            }
        } catch (error) {
            console.error("Error fetching SEO data:", error);
        }
    };
    const searchall = async (query) => {
        try {
            if (!query) {
                setSearchdata([]);
                return;
            }

            const response = await axios.get(`${BASE_URL}search`, {
                params: {
                    query: query,   // 👈 yahi search key
                },
                headers: {
                    Accept: "application/json",
                },
            });

            if (response.data.success === true) {
                setSearchdata(response.data.data);
                setShowDropdown(true);
            } else {
                setSearchdata([]);
            }
        } catch (error) {
            console.error("Search error:", error);
            setSearchdata([]);
        }
    };

    const getRedirectUrl = (item) => {
        const identifier = item.slug ? item.slug : item.id;

        switch (item.type) {
            case "blog":
                return `/blog-details/${identifier}`;

            case "current_affair":
                return `/current-affairs-details/${identifier}`;

            case "upcoming_exam":
                return `/upcomming-exam-details/${identifier}`;

            case "competitive_commission":
                return `/${identifier}`;

            default:
                return "/";
        }
    };

    const getTypeLabel = (type) => {
        switch (type) {
            case "blog":
                return "Blog";

            case "current_affair":
                return "Current Affair";

            case "upcoming_exam":
                return "Upcoming Exam";

            case "competitive_commission":
                return "Competitive Commission";

            default:
                return "";
        }
    };

    const highlightText = (text, query) => {
        if (!query) return text;

        const regex = new RegExp(`(${query})`, "ig");
        const parts = text.split(regex);

        return parts.map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={index} className="search-highlight">
                    {part}
                </span>
            ) : (
                part
            )
        );
    };


    return (
        <>
            <RewardBanner userdata={userdata} bonusPoints={100} />

            <div className="main-header">
                <div className='header'>

                    <div className='top-header' >
                        <div className='header-menu'><Link to={"/"} style={{ textDecoration: "none", color: "#000000" }}><p><IoHomeOutline style={{ marginTop: "-4px" }} /> Home</p></Link></div>

                        <div className='d-flex align-items-center gap-2'>

                            {showdata?.test_series === "yes" && (<div className='header-menu'><Link to={"/test-series-page"} style={{ textDecoration: "none", color: "#000000" }}><p>Test Series</p></Link></div>)}

                            {showdata?.previous_year_papers === "yes" && (
                                <div className='header-menu'><Link to={"/previous-year-paper"} style={{ textDecoration: "none", color: "#000000" }}><p>Previous Year Papers
                                </p></Link></div>

                            )}
                            {showdata?.resources === "yes" && (
                                <div className='header-menu'><Link to={"/resources"} style={{ textDecoration: "none", color: "#000000" }}><p>Resources
                                </p></Link></div>

                            )}

                            {showdata?.blogs === "yes" && (
                                <div className='header-menu'><Link to={"/blogs"} style={{ textDecoration: "none", color: "#000000" }}><p>Blogs</p></Link></div>
                            )}
                            {showdata?.current_affairs === "yes" && (
                                <div className='header-menu'><Link to={"/current-affairs"} style={{ textDecoration: "none", color: "#000000" }}><p>Current Affairs</p></Link></div>
                            )}
                            {showdata?.upcoming_examination === "yes" && (
                                <div className='header-menu'><Link to={"/upcomming-exam"} style={{ textDecoration: "none", color: "#000000" }}><p>Upcoming Exam</p></Link></div>
                            )}







                            <div className='cart-menu'>
                                {userdata === null ?
                                    <Link to={"/log-in"} style={{ textDecoration: "none", color: "#fff" }}>
                                        <p className='text m-0' style={{ color: "#fff", border: "1px solid #fff", padding: " 3px 5px", borderRadius: "3px" }}> <span><CiUser /></span>  Login / Signup</p>
                                    </Link>
                                    :

                                    <>
                                        <p
                                            id="fade-button"
                                            style={{
                                                color: "#fff",
                                                border: "1px solid #fff",
                                                padding: "3px 5px",
                                                borderRadius: "3px",
                                                display: "flex",
                                                alignItems: "center", // Align items vertically in the center
                                            }}
                                            aria-controls={open1 ? 'fade-menu' : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={open1 ? 'true' : undefined}
                                            onClick={handleClick1}
                                            className="text m-0"
                                        >
                                            <span>
                                                <img
                                                    style={{
                                                        width: "35px",
                                                        height: "35px",
                                                        borderRadius: "50%",
                                                        marginRight: "10px",
                                                    }}
                                                    src={IMGAGE_URL + userdata1.image}
                                                    alt="User"
                                                />
                                            </span>
                                            {userdata1.name} <MdArrowDropDown />
                                        </p>

                                        <Menu
                                            id="fade-menu"
                                            MenuListProps={{
                                                'aria-labelledby': 'fade-button',
                                            }}
                                            anchorEl={anchorEl1}
                                            open={open1}
                                            onClose={handleClose1}
                                            TransitionComponent={Fade}
                                            PaperProps={{
                                                style: {
                                                    width: '250px', // Ensure a fixed width for the menu
                                                    padding: '5px',
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                            }}
                                        >
                                            <MenuItem>
                                                <Link
                                                    to="/student-admin"
                                                    style={{
                                                        border: "none",
                                                        textDecoration: "none",
                                                        color: "#000",
                                                        width: '100%',
                                                    }}
                                                >
                                                    Student Dashboard
                                                </Link>
                                            </MenuItem>
                                            <MenuItem> <Link
                                                to="/orders"
                                                style={{
                                                    border: "none",
                                                    textDecoration: "none",
                                                    color: "#000",
                                                    width: '100%',
                                                }}
                                            >My Orders</Link></MenuItem>
                                            <MenuItem> <Link
                                                to="/package-test-series"
                                                style={{
                                                    border: "none",
                                                    textDecoration: "none",
                                                    color: "#000",
                                                    width: '100%',
                                                }}
                                            >Test Series</Link></MenuItem>
                                            <MenuItem> <Link
                                                to="/test-results"
                                                style={{
                                                    border: "none",
                                                    textDecoration: "none",
                                                    color: "#000",
                                                    width: '100%',
                                                }}
                                            >Test Results</Link></MenuItem>
                                            <MenuItem> <Link
                                                to="/my-interview"
                                                style={{
                                                    border: "none",
                                                    textDecoration: "none",
                                                    color: "#000",
                                                    width: '100%',
                                                }}
                                            >Interviews</Link></MenuItem>
                                            <MenuItem> <Link
                                                to="/live-class-manage-schedule"
                                                style={{
                                                    border: "none",
                                                    textDecoration: "none",
                                                    color: "#000",
                                                    width: '100%',
                                                }}
                                            >Live Classes</Link></MenuItem>
                                            <MenuItem> <Link
                                                to="/wallet"
                                                style={{
                                                    border: "none",
                                                    textDecoration: "none",
                                                    color: "#000",
                                                    width: "100%",
                                                }}
                                            >
                                                Wallet{" "}
                                                <span style={{ color: "green" }}>
                                                    (<BsCurrencyRupee />
                                                    {Number(userdata1.wallet_amount).toLocaleString("en-IN")}/-)
                                                </span>
                                            </Link>
                                            </MenuItem>
                                            <MenuItem onClick={logout}>Logout</MenuItem>
                                        </Menu>
                                    </>

                                }

                            </div>
                        </div>


                    </div>

                </div>
                <div className='navbar'>
                    <div className='navbar-menu'>
                        <div className='logo'>
                            <Link to={"/"}><img src={Logo} alt='logo'></img></Link>
                            <p className='m-0' >A Unit of BK Lal Educational (OPC) Pvt. Ltd</p>
                        </div>
                        <div className='navbar-menu-data'>
                            <div className="search-wrapper" style={{ position: "relative" }}>
                                <div className="input-group d-flex" >
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={searchText}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setSearchText(value);
                                            searchall(value); // 👈 type pe call
                                        }}
                                        onFocus={() => searchData.length && setShowDropdown(true)}
                                    />

                                    <div className="input-group-append">
                                        <span className="input-group-text">
                                            <CiSearch />
                                        </span>
                                    </div>
                                </div>

                                {/* DROPDOWN */}
                                {showDropdown && searchData.length > 0 && (
                                    <div className="search-dropdown">
                                        {searchData.map((item, index) => (
                                            <div
                                                key={index}
                                                className="search-item"
                                                onClick={() => {
                                                    window.location.href = getRedirectUrl(item);
                                                    setShowDropdown(false);
                                                }}
                                            >
                                                <span className="search-title">
                                                    {highlightText(item.title || item.name, searchText)}
                                                </span>

                                                <span className="search-type-badge">
                                                    {getTypeLabel(item.type)}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>



                            {showdata?.live_classes === "yes" && (
                                <>
                                    <div className='cart-menu'>
                                        <p className='text m-0' style={{ fontSize: "18px" }}><span><FaVideo style={{ color: "black" }} />&nbsp; </span><Link to={"/live-classes"} style={{ textDecoration: "none", color: "#000000" }}>  Live Classes</Link></p>
                                    </div>
                                    <div className='line'>

                                    </div>
                                </>
                            )}
                            {showdata?.interviews === "yes" && (

                                <div className='cart-menu'>
                                    <p className='text m-0' style={{ fontSize: "18px" }}><span><FcConferenceCall />&nbsp; </span><Link to={"/live-interview"} style={{ textDecoration: "none", color: "#000000" }}>  Live Interview</Link></p>
                                </div>
                            )}

                            {showdata?.teacher_on_call === "yes" && (
                                <div className='cart-menu' style={{ marginRight: "6px" }}>
                                    <button><Link to={'/teacher-on-call'} style={{ textDecoration: "none", color: 'white', display: 'flex', gap: '10px' }}><span><MdHeadsetMic /></span> Teacher On Call</Link></button>
                                </div>

                            )}

                        </div>
                    </div>

                </div>
                <div className='mobile--navbar'>
                    <Menubar />
                </div>

                <div className='slider-container'>
                    <div className='main-category'>
                        <button className="prev" onClick={() => slide(-1)} title="Previous Slide"><GrPrevious alt="Previous" /></button>


                        <div className='exam-category-list' ref={sliderRef} style={{ transform: `translateX(${-slideIndex}px)` }}>


                            {data
                                .filter(item => item._name !== "Current Affairs")
                                .map((item, index) => (
                                    <React.Fragment key={item.id}>
                                        <Link
                                            to={`/${item.slug}`}
                                            style={{ textDecoration: 'none', color: "#000000" }}
                                        >
                                            <div
                                                className={`jk-menu-btn ${item.show_as_premium === "yes" ? "jk-premium" : ""}`}
                                            >
                                                <span>{item._name}</span>

                                                {/* {item.show_as_premium === "yes" && (
  <img
    src={Gif}
    alt="Premium"
    style={{
     
      height: "26px",
      objectFit: "contain",
    }}
  />
)} */}

                                            </div>
                                        </Link>

                                        {/* Vertical line except after last item */}
                                        {/* {index !== data.length - 2 && <div className="jk-v-divider"></div>} */}
                                    </React.Fragment>
                                ))
                            }



                        </div>
                        <button className="next" onClick={() => slide(1)} title="Next Slide"><GrNext alt="Next" /></button>


                    </div>
                    <div className='right-drawer'>
                        <h2><AnchorTemporaryDrawer /></h2>
                    </div>
                </div>

            </div>

            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >{clickedItemData?.map((e, index) => (
                <MenuItem key={index} onClick={handleClose}>
                    <Link to={`/subject-details/${e.slug}`} style={{ textDecoration: 'none', color: "#000000" }}>
                        {e.category_name}
                    </Link>

                </MenuItem>

            ))}


            </Menu>
        </>
    );
}

export default Header;
